import { combineReducers } from 'redux';

import domainReducer from "./domainReducer";

export default combineReducers({
  domains: domainReducer
});
